<template>
  <div class="form-wrapper">
    <div class="container form-page">
      <form-header />
      <template v-if="Object.keys(article).length">
        <div class="row">
          <div class="col-12 bg-white rounded mt-4 pb-4 pt-4 border">
            <div class="article-header">
              <h1>{{article.translations[$i18n.locale].title}}</h1>
              <hr>
            </div>
            <div class="article-description" v-if="article.translations[$i18n.locale].description">
              <i>{{article.translations[$i18n.locale].description}}</i>
            </div>
            <div class="article-body">
              <div v-html="article.translations[$i18n.locale].body"></div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="container fixed-bottom">
      <div class="row">
        <router-link to="/" class="btn btn-success mt-3 justify-content-center mx-auto article-back-btn">
            {{ $t('article.back_btn') }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/article.css'
import articleApi from '@/api/articles'
import FormHeader from '@/components/form/FormHeader'

export default {
  components: {FormHeader},
  data(){
    return {
      article: {}
    }
  },
  mounted() {
    articleApi.getItem(this.$route.params.id).then((response) => this.article = response.data)
  },
}
</script>